import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { DateUtils } from '@app/utils/date';
import { TranslateService } from '@ngx-translate/core';
import { formatDistance } from 'date-fns';

@Injectable()
@Pipe({
  name: 'portalTimeAgo',
  pure: false,
  standalone: true,
})
export class PortalTimeAgoPipe implements PipeTransform {
  language!: string;

  constructor(private translateService: TranslateService) {}

  transform(value: Date) {
    if (value == null) {
      return null;
    }

    const now = new Date();
    const locale = DateUtils.getDateFnsLocale(this.translateService.currentLang);

    return formatDistance(value, now, {
      addSuffix: true,
      locale,
    });
  }
}
